<template>
    <div v-if="allowReviews" id="review">
        <div class="review-container">
            <div class="row" v-if="reviewsCount > reviewsPerPage">
                <PaginationRow 
                    :recordsCount="reviewsCount" 
                    :perPage="reviewsPerPage" 
                    :currPage="pageNumber"
                    @pageChange="changePage" 
                />
            </div>
            <div :key="pageNumber" class="review-list">
                <div class="review-item" v-for="review in reviews" :key="review.id || review.created_at">
                    <p class="review-meta-data"><StartRating :rating="review.rating" /> {{ formatUsDate(review.created_at) }}</p>
                    <p class="reviewer-name">{{ review.first_name }}</p>
                    <div v-html="review.review" class="review-content"></div>
                </div>
            </div>
            <div class="row" v-if="reviewsCount > reviewsPerPage">
                <PaginationRow 
                    :recordsCount="reviewsCount" 
                    :perPage="reviewsPerPage" 
                    :currPage="pageNumber"
                    @pageChange="changePage" 
                />
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import { PaginationRow, StartRating } from '@/components';
import axios from 'axios';

const props = defineProps({
    existingReviews: {
        type: Array,
        required: true
    },
    totalReviews: {
        type: Number,
        required: true
    },
    perPage: {
        type: Number,
        required: false,
        default: 4
    },
    allowReviews: {
        type: Boolean,
        required: true
    },
    slug: {
        type: String,
        required: true
    },
    page: {
        type: Number,
        required: false,
        default: 1
    }
});

const pageNumber = ref(props.page);
const reviews = ref([...props.existingReviews]);
const reviewsCount = ref(props.totalReviews);
const reviewsPerPage = ref(props.perPage);

watch(
  () => props.existingReviews,
  (value) => {
    if (pageNumber.value === 1) {
      reviews.value = [...value];
    }
  }
);

watch(
  () => props.totalReviews,
  (value) => {
    reviewsCount.value = value;
  }
);

watch(
  () => props.perPage,
  (value) => {
    if (value) {
      reviewsPerPage.value = value;
    }
  }
);

const fetchProductReviews = () => {
  axios
    .post(
      `${process.env.VUE_APP_API_BASE}auth/getProductReviews`,
      {
        slug: props.slug,
        page_number: pageNumber.value,
      },
      {
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
    .then((response) => {
      reviews.value = response.data.data.items || [];
      if (typeof response.data.data.total_reviews === 'number') {
        reviewsCount.value = response.data.data.total_reviews;
      }
      if (response.data.data.per_page) {
        reviewsPerPage.value = response.data.data.per_page;
      }
    });
};

const changePage = (newPageNumb) => {
  if (newPageNumb === pageNumber.value) {
    return;
  }
  pageNumber.value = newPageNumb;
  fetchProductReviews();
};

const formatUsDate = (dateString) => {
  if (!dateString) {
    return "";
  }
  const rawDate = new Date(dateString);
  return (
    rawDate.getMonth() +
    1 +
    "-" +
    rawDate.getDate() +
    "-" +
    rawDate.getFullYear()
  );
};
</script>
<style scoped>
#review .table{
    margin-bottom: 30px;
}
#review .table tr:nth-of-type(odd){
    background-color: #ec7f62;
}
#review .table tr:nth-of-type(odd) td{
    color: #fff;
}
#review .table tr th,
#review .table tr td{
    border: 1px solid #ececec;
    padding: 8px;
}
#review .table tr td strong{
    margin: 0;
    font-size: 16px;
}
#review .table tr td p{
    font-size: 14px;
    margin-bottom: 10px;
}
#review .table tr td .fa-stack{
    width: 20px;
    height: 20px;
    line-height: 15px;
}
#review .table tr td .fa-stack i{
    font-size: 15px;
}
#review .table tr td .fa-stack .fa-star{
    color: #c3c3c3;
}
#review .table tr td .fa-stack .fa-stack-2x{
    color: #f4c962;
}
#review .fa-stack{
    width: 20px;
    height: 20px;
    line-height: 15px;
}

.review-meta-data {
  display: flex;
  align-items: center;
  gap: var(--gap-10);
  font-size: var(--font-size-14);
  line-height: 18px;
  color: var(--body-color);
  font-style: normal;
  font-weight: 400;
  margin-bottom: var(--gap-10);
}
.reviewer-name {
  color: var(--body-color);
  font-size: var(--font-size-16);
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  text-transform: capitalize;
  margin-bottom: var(--gap-10);
}
.review-content {
  font-size: var(--font-size-md, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  margin-bottom: 0;
}
.review-list {
  display: flex;
  flex-direction: column;
  gap: var(--gap-30);
}
#review-list .fa-stack .fa-stack-2x,
.review-list .fa-stack .fa-stack-2x {
    color: #ec7f62;
}
#review-list .fa-star,
.review-list .fa-star {
    color: #ec7f62;
}
#review-list .fa-stack i,
.review-list .fa-stack i {
    font-size: 15px;
}
hr.review-hr {
  width: 98%;
  color: #e5e5e5;
  opacity: 0.7;
  height: 0.5px;
}
</style>
